export class StackedChartItem {
    public name: string = "";
    public amount1: number = 0;
    public amount2: number = 0;
    public amount3: number = 0;
    public amount4: number = 0;
    public payload: any = "";
}


// WEBPACK FOOTER //
// ./src/models/StackedChartItem.ts